/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Tax_IdInputs */

const en_label_tax_id = /** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax ID`)
};

const es_label_tax_id = /** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación Fiscal`)
};

const fr_label_tax_id = /** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro d'identification fiscale`)
};

const de_label_tax_id = /** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuernummer`)
};

const id_label_tax_id = /** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NPWP / ID Pajak`)
};

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const ja_label_tax_id = en_label_tax_id;

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const zh_label_tax_id = en_label_tax_id;

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const ar_label_tax_id = en_label_tax_id;

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const it_label_tax_id = en_label_tax_id;

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const ru_label_tax_id = en_label_tax_id;

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const pt_label_tax_id = en_label_tax_id;

/** @type {(inputs: Label_Tax_IdInputs) => LocalizedString} */
const ko_label_tax_id = en_label_tax_id;

/**
* | output |
* | --- |
* | "Tax ID" |
*
* @param {Label_Tax_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_tax_id = /** @type {((inputs?: Label_Tax_IdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Tax_IdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_tax_id(inputs)
	if (locale === "es") return es_label_tax_id(inputs)
	if (locale === "fr") return fr_label_tax_id(inputs)
	if (locale === "de") return de_label_tax_id(inputs)
	if (locale === "ja") return ja_label_tax_id(inputs)
	if (locale === "zh") return zh_label_tax_id(inputs)
	if (locale === "ar") return ar_label_tax_id(inputs)
	if (locale === "id") return id_label_tax_id(inputs)
	if (locale === "it") return it_label_tax_id(inputs)
	if (locale === "ru") return ru_label_tax_id(inputs)
	if (locale === "pt") return pt_label_tax_id(inputs)
	return ko_label_tax_id(inputs)
});